/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GenerateTreatmentPlanForPatientDto
 */
export interface GenerateTreatmentPlanForPatientDto {
    /**
     * The patient ID to generate treatment plan for
     * @type {string}
     * @memberof GenerateTreatmentPlanForPatientDto
     */
    patientId: string;
    /**
     * The provider ID who is generating the treatment plan
     * @type {string}
     * @memberof GenerateTreatmentPlanForPatientDto
     */
    providerId?: string;
    /**
     * The budget constraints for the treatment plan
     * @type {string}
     * @memberof GenerateTreatmentPlanForPatientDto
     */
    budgetConstraints?: string;
    /**
     * The exclusions for the treatment plan
     * @type {string}
     * @memberof GenerateTreatmentPlanForPatientDto
     */
    exclusions?: string;
    /**
     * The clinical focus for the treatment plan
     * @type {string}
     * @memberof GenerateTreatmentPlanForPatientDto
     */
    clinicalFocus?: string;
    /**
     * The language of the protocol
     * @type {string}
     * @memberof GenerateTreatmentPlanForPatientDto
     */
    language?: GenerateTreatmentPlanForPatientDtoLanguageEnum;
}


/**
 * @export
 */
export const GenerateTreatmentPlanForPatientDtoLanguageEnum = {
    En: 'en',
    Fr: 'fr',
    Es: 'es',
    Ar: 'ar'
} as const;
export type GenerateTreatmentPlanForPatientDtoLanguageEnum = typeof GenerateTreatmentPlanForPatientDtoLanguageEnum[keyof typeof GenerateTreatmentPlanForPatientDtoLanguageEnum];


/**
 * Check if a given object implements the GenerateTreatmentPlanForPatientDto interface.
 */
export function instanceOfGenerateTreatmentPlanForPatientDto(value: object): value is GenerateTreatmentPlanForPatientDto {
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    return true;
}

export function GenerateTreatmentPlanForPatientDtoFromJSON(json: any): GenerateTreatmentPlanForPatientDto {
    return GenerateTreatmentPlanForPatientDtoFromJSONTyped(json, false);
}

export function GenerateTreatmentPlanForPatientDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateTreatmentPlanForPatientDto {
    if (json == null) {
        return json;
    }
    return {
        
        'patientId': json['patientId'],
        'providerId': json['providerId'] == null ? undefined : json['providerId'],
        'budgetConstraints': json['budgetConstraints'] == null ? undefined : json['budgetConstraints'],
        'exclusions': json['exclusions'] == null ? undefined : json['exclusions'],
        'clinicalFocus': json['clinicalFocus'] == null ? undefined : json['clinicalFocus'],
        'language': json['language'] == null ? undefined : json['language'],
    };
}

export function GenerateTreatmentPlanForPatientDtoToJSON(json: any): GenerateTreatmentPlanForPatientDto {
    return GenerateTreatmentPlanForPatientDtoToJSONTyped(json, false);
}

export function GenerateTreatmentPlanForPatientDtoToJSONTyped(value?: GenerateTreatmentPlanForPatientDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patientId': value['patientId'],
        'providerId': value['providerId'],
        'budgetConstraints': value['budgetConstraints'],
        'exclusions': value['exclusions'],
        'clinicalFocus': value['clinicalFocus'],
        'language': value['language'],
    };
}

